<template>
	<div class="fz-14 flex-row-align-center flex-just-between">
		<el-tabs v-model="tabName1" style="flex: 1; min-width: 0">
			<el-tab-pane :name="item.name" :label="`${item.label}${item.value} `" v-for="(item, index) in baseInfo" :key="item.key">
				<div slot="label" class="flex-row-align-center mr-16">
					<div v-if="item.key === 'add_anchor_num'" class="line"></div>
					<Explain
						v-if="item.explain"
						inline
						:size="14"
						:width="220"
						:content="item.explain"
						placement="top"
						icon="icon-a-help-circlebangzhu-mian"
					></Explain>
					<span class="fz-12 yx-color-text-regular">
						{{ item.label }}
					</span>
					<span class="DIN yx-color-text-primary fz-16 ml-6">
						{{ item.value }}
					</span>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import { formatPercent } from '@/filters';
import { deepClone } from '@/utils/common';
import Explain from '@/components/common/explain/index.vue';

export default {
	name: 'sampleOrderStatistics',
	components: { Explain },
	props: {
		sampleObj: {
			type: Object,
			default: () => {},
		},
		tabName: {
			type: String,
			default: '0',
		},
	},
	data() {
		return {
			tabName1: '0', // 为了不报错，没卵用
			statisticsALLMap: new Map([
				['order_num', { key: 'order_num', label: '订单数', value: '', explain: '' }],
				['send_order_num', { key: 'send_order_num', label: '寄样数', value: '', explain: '已发货样品订单数' }],
				['send_product_num', { key: 'send_product_num', label: '寄样商品数', value: '', explain: '已发货样品订单对应的商品数' }],
				['wait_delivery_order_num', { key: 'wait_delivery_order_num', label: '待交付数', value: '', explain: '已到货、确认带货的样品订单数' }],
				[
					'delivery_order_num',
					{ key: 'delivery_order_num', label: '已交付数', value: '', explain: '已交付合作进度下关联的已到货、确认带货的样品订单数' },
				],
				['pay_order_num', { key: 'pay_order_num', label: '出单数', value: '', explain: '有出单的合作进度下关联的已到货、确认带货的样品订单数' }],
				['delivery_order_rate', { key: 'delivery_order_rate', label: '寄样交付率', value: '', explain: '已交付数/寄样数' }],
				['pay_order_rate', { key: 'pay_order_rate', label: '寄样出单率', value: '', explain: '出单数/寄样数' }],
				['add_anchor_num', { key: 'add_anchor_num', label: '申样达人数', value: '', explain: '' }],
				['send_anchor_num', { key: 'send_anchor_num', label: '寄样达人数', value: '', explain: '' }],
				['delivery_anchor_num', { key: 'delivery_anchor_num', label: '交付达人数', value: '', explain: '' }],
				['pay_anchor_num', { key: 'pay_anchor_num', label: '出单达人数', value: '', explain: '' }],
			]),
			statisticsMap: new Map([
				['order_num', { key: 'order_num', label: '订单数', value: '', explain: '' }],
				['anchor_num', { key: 'anchor_num', label: '达人数', value: '', explain: '' }],
				['institution_num', { key: 'institution_num', label: '团长数', value: '', explain: '' }],
			]),
		};
	},
	computed: {
		// 组装统计信息
		baseInfo() {
			let statisticsObj = deepClone(this.sampleObj);
			const statisticsMap = this.tabName === '0' ? this.statisticsALLMap : this.statisticsMap;
			if (this.tabName === '0') {
				statisticsObj.delivery_order_rate = formatPercent(+statisticsObj.delivery_order_rate);
				statisticsObj.pay_order_rate = formatPercent(+statisticsObj.pay_order_rate);
			}
			for (const [key, value] of statisticsMap.entries()) {
				if (statisticsObj.hasOwnProperty(key)) {
					value.value = statisticsObj[key];
				}
			}
			return Array.from(statisticsMap.values()) || [];
		},
	},
	methods: {},
};
</script>

<style lang="less" scoped>
.rules-manage {
	right: 0;
	top: 8px;
	z-index: 999;
}
.line {
	width: 1px;
	height: 8px;
	margin: 0 16px 0 0;
	background-color: @color-gy5;
}
.statisticalScrollbar {
	white-space: nowrap;
	overflow-x: auto;
	width: 100%;
	max-width: 1260px;
}
/deep/ .el-tabs__item {
	padding: 0;
}
/deep/ .el-tabs__item.is-active {
	color: @color-text-primary;
}
/deep/ .el-tabs__item:hover {
	cursor: auto;
}
/deep/.el-tabs__active-bar {
	background-color: transparent;
}
/deep/ .el-tabs__nav-wrap::after {
	position: static !important;
}
/deep/ .el-tabs__header {
	margin: 0;
}
/deep/ .el-tabs__nav-prev,
/deep/ .el-tabs__nav-next {
	top: 3px;
}
</style>
